export enum SubassignmentInfoLabel {
    Employee = 'Employee',
    Placement = 'Placement',
    BaseRate = 'Base Rate',
    PayRate = 'Effective Pay Rate',
}
